// extracted by mini-css-extract-plugin
export default {"genericValueTooltip":"GenericTooltipListExpressions_genericValueTooltip__Rgx5r"};